// extracted by mini-css-extract-plugin
export default {"root":"TabBindings_root__5wZHq","loader":"TabBindings_loader__u12i3","save":"TabBindings_save__DbdUT"};